<template>
  <div v-if="orderList && orderList.length > 0">
    <div class="m-clear m-comwid">
      <h3 style="margin-bottom: 10px">
        <span style="left: 108px"
          >预定情况<i>({{ totalNum }})</i></span
        >
      </h3>
      <!--<p class="m-orbtn"><a :class="{'m-add':!isshow,'m-sub':isshow}"  @click="setshow"></a></p>-->
    </div>
    <div>
      <div class="m-clear m-ordinfo" style="background-color: #fff">
        <div class="m-comwid m-comment">
          <div class="userodr">
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
              <tbody>
                <tr>
                  <th>档期</th>
                  <th>服务类型</th>
                  <th>预定人</th>
                  <th>预定时间</th>
                </tr>

                <template v-for="(item, index) in orderList">
                  <collapseTransition name="order">
                    <tr v-show="index < num">
                      <td>
                        {{ formateData(item.weddingDate, "YYYY-MM-DD") }}
                      </td>
                      <td>{{ item.serviceName }}</td>
                      <td>
                        <template v-if="item.userName"
                          >{{ item.userName.substring(0, 1) }}**</template
                        >
                        <template v-else>***</template>
                      </td>
                      <td>{{ formateData(item.ctime, "YYYY-MM-DD HH:mm") }}</td>
                    </tr>
                  </collapseTransition>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <p class="m-orbtn" v-show="totalNum > 4 && isshow">
        <a
          style="width: auto; color: #979797; height: 30px; opacity: 0.5"
          @click="setshow(0)"
          >加载更多</a
        >
      </p>

      <collapseTransition name="page">
        <div class="m-clear" v-if="pageNum > 1 && !isshow">
          <Pag
            :page="pageNum"
            :total="totalNum"
            :curr="curNum"
            :rowsNum="rows"
            methName="updateOrdPage"
          ></Pag>
        </div>
      </collapseTransition>
      <p class="m-orbtn" v-show="totalNum > 4 && !isshow">
        <a
          style="width: auto; color: #979797; height: 30px; opacity: 0.5"
          @click="setshow(1)"
          >收起</a
        >
      </p>
    </div>
  </div>
</template>
<script>
import Pag from "../common/Page.vue";
import api from "../../config/api.js";
import dayjs from "dayjs";
import collapseTransition from "../common/collapseTransition.vue";
export default {
  name: "order",
  props: ["workerId"],
  data: function () {
    return {
      totalNum: 1,
      curNum: 1,
      pageNum: 1,
      start: 0,
      rows: 20,
      wid: this.workerId,
      orderList: [],
      isshow: true,
      num: 4,
    };
  },
  components: { Pag, collapseTransition },
  created: function () {
    let vm = this;
    vm.getOrder();
    vm.bus.$on("updateOrdPage", function (obj) {
      vm.start = obj.start;
      vm.curNum = obj.current;
      vm.getOrder();
    });
  },
  methods: {
    setshow: function (type) {
      if (type == 1) {
        this.num = 4;
      } else {
        this.num = 100000;
      }

      this.isshow = !this.isshow;
    },
    formateData: function (ctime, type) {
      return ctime ? dayjs(new Date(ctime)).format(type) : ctime;
    },
    getOrder: function () {
      let vm = this;
      let url = api.API_URL + "worker/v1/query/order/page";
      vm.getNewAjax(
        url,
        { workerId: vm.wid, start: vm.start, rows: vm.rows },
        function (result) {
          //得到所有数据
          vm.orderList = result.records;
          vm.totalNum = result.totalRecord;
          vm.pageNum = Math.ceil(result.totalRecord / vm.rows);
        },
        function (result) {},
        function () {}
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// _worker_order.vue?cfb2c072